export const WHATSAPP_NUMBER = "554133767066";
export const WHATSAPP_DISPLAY = "(41) 3376-7066";
export const MAPS_URL = "https://share.google/zdeSNcL0olknRoja7";
export const IFOOD_URL = "https://www.ifood.com.br/delivery/curitiba-pr/giga-acai---hauer-hauer/8cd289ec-b106-48ad-9a5e-813a89e22955";
export const INSTAGRAM_URL = "https://www.instagram.com/gigaacaioficial";
export const SPOON_PRICE = 0.5;
export const STORE_HOURS_WEEK = "Seg a Sáb · 11h30 às 18h30";
export const STORE_HOURS_SUNDAY = "Dom · 11h30 às 18h00";
export const STORE_HOURS = `${STORE_HOURS_WEEK} | ${STORE_HOURS_SUNDAY}`;

export const DELIVERY = { base: 5, includedKm: 4, perKm: 1.5, freeAbove: 35, freeKm: 2 };
export const DELIVERY_KM_OPTIONS = [
  { km: 2, label: "Até 2 km" },
  { km: 4, label: "De 2 a 4 km" },
  { km: 6, label: "De 4 a 6 km" },
  { km: 8, label: "De 6 a 8 km" },
  { km: 10, label: "De 8 a 10 km" },
];
export const calcDeliveryFee = (subtotal, km) => {
  if (subtotal >= DELIVERY.freeAbove && km <= DELIVERY.freeKm) return 0;
  if (km <= DELIVERY.includedKm) return DELIVERY.base;
  return DELIVERY.base + (km - DELIVERY.includedKm) * DELIVERY.perKm;
};

export const STORE_COORDS = { lat: -25.4789393, lng: -49.2424259 };
export const STORE_ADDRESS = "Rua Alcino Guanabara, 1757 · Hauer, Curitiba";

export const haversineKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
};

export const SIZES = [
  { id: "300", label: "300 ml", price: 13 },
  { id: "400", label: "400 ml", price: 15, popular: true },
  { id: "500", label: "500 ml", price: 17 },
  { id: "700", label: "700 ml", price: 20 },
  { id: "1l", label: "1 Litro", price: 30 },
  { id: "2l", label: "2 Litros", price: 54 },
];

export const FLAVORS = [
  { id: "acai", label: "Açaí" },
  { id: "cupuacu", label: "Cupuaçu" },
  { id: "meio", label: "Meio a Meio" },
];

export const ADDON_CATEGORIES = [
  {
    id: "frutas",
    name: "Frutas",
    color: "#10B981",
    items: [
      { name: "Banana", price: 3.5 },
      { name: "Kiwi", price: 4 },
      { name: "Morango", price: 4 },
      { name: "Maracujá", price: 3.5 },
      { name: "Manga", price: 3.5 },
      { name: "Uva", price: 4 },
      { name: "Abacaxi", price: 3.5 },
      { name: "Cereja", price: 4.5 },
    ],
  },
  {
    id: "diversos",
    name: "Diversos",
    color: "#F59E0B",
    items: [
      { name: "Leite Condensado", price: 3.5 },
      { name: "Leite em Pó", price: 4 },
      { name: "Mel", price: 3.5 },
      { name: "Oreo", price: 3.5 },
      { name: "Paçoca", price: 3.5 },
      { name: "Amendoim", price: 3.5 },
      { name: "Leite em Pó S/ Lactose", price: 4.5 },
      { name: "Leite Condensado S/ Lactose", price: 4 },
      { name: "Suspiro", price: 3.5 },
    ],
  },
  {
    id: "chocolates",
    name: "Chocolates",
    color: "#EC4899",
    items: [
      { name: "Bis Branco", price: 3.5 },
      { name: "Bis Preto", price: 3.5 },
      { name: "Confeti", price: 4 },
      { name: "Gotas de Chocolate", price: 3.5 },
      { name: "Ovomaltine", price: 3.5 },
      { name: "Laka", price: 4 },
      { name: "Diamante Negro", price: 4 },
      { name: "Prestígio", price: 4 },
      { name: "Kit Kat", price: 5.5 },
      { name: "Nutella", price: 6 },
    ],
  },
  {
    id: "cereais",
    name: "Cereais",
    color: "#06B6D4",
    items: [
      { name: "Granola", price: 3.5 },
      { name: "Aveia", price: 3.5 },
      { name: "Chocoballs", price: 3.5 },
      { name: "Farinha Láctea", price: 3.5 },
      { name: "Neston", price: 3.5 },
    ],
  },
  {
    id: "mousses",
    name: "Mousses",
    color: "#F97316",
    items: [
      { name: "Mousse de Morango", price: 4 },
      { name: "Mousse de Kinder Bueno", price: 4 },
      { name: "Mousse de Leite em Pó", price: 4 },
      { name: "Mousse de Maracujá", price: 4 },
      { name: "Mousse de Limão", price: 4 },
    ],
  },
  {
    id: "whey",
    name: "Whey Protein",
    color: "#EF4444",
    items: [
      { name: "Whey de Chocolate", price: 6 },
      { name: "Whey de Baunilha", price: 6 },
      { name: "Whey de Morango", price: 6 },
    ],
  },
  {
    id: "coberturas",
    name: "Coberturas",
    color: "#3B82F6",
    items: [
      { name: "Cobertura de Chocolate", price: 3 },
      { name: "Cobertura de Morango", price: 3 },
    ],
  },
];

export const ROLETA = { price: 54.9, freeAddons: 6 };

export const PROMOS = [
  { day: 1, dayName: "Segunda-Feira", short: "SEG", combo: "Leite em Pó + Leite Condensado", color: "#3B82F6", image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/0n8vpvif_WhatsApp%20Image%202026-09-17%20at%2013.45.57%20%281%29.jpeg" },
  { day: 2, dayName: "Terça-Feira", short: "TER", combo: "Confete + Cobertura de Chocolate", color: "#EC4899", image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/v9tvsnbj_WhatsApp%20Image%202026-09-17%20at%2013.45.57%20%282%29.jpeg" },
  { day: 3, dayName: "Quarta-Feira", short: "QUA", combo: "Morango + Nutella", color: "#10B981", image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/3akmwznf_WhatsApp%20Image%202026-09-17%20at%2013.45.57%20%283%29.jpeg" },
  { day: 4, dayName: "Quinta-Feira", short: "QUI", combo: "Banana + Paçoca", color: "#F59E0B", image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/eige8mpt_WhatsApp%20Image%202026-09-17%20at%2013.53.07.jpeg" },
  { day: 5, dayName: "Sexta-Feira", short: "SEX", combo: "Morango + Leite em Pó", color: "#EF4444", image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/2yboi0l5_WhatsApp%20Image%202026-09-17%20at%2013.57.54.jpeg" },
];
export const PROMO_PRICE = 15;

export const EXTRA_GROUPS = [
  {
    id: "pote-1l",
    title: "Pote de Sorvete 1 Litro",
    price: 32,
    color: "#3B82F6",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/6e5de91c74b075ac_WhatsApp%20Image%202026-10-17%20at%2015.09.17.jpeg",
    flavors: ["Abacaxi ao Vinho", "Banana Trufada", "Chocomenta", "Duttela", "Duffaelo", "Iogurte com Amarena", "Morango Trufado", "Ninho Trufado", "Kit Chef"],
  },
  {
    id: "pote-2l",
    title: "Pote de Sorvete 2 Litros",
    price: 42,
    color: "#A855F7",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/6ccfc64053c0c103_WhatsApp%20Image%202026-10-17%20at%2015.08.17.jpeg",
    flavors: ["Morango Premium", "Napolitano", "Flocos", "Unicórnio", "Chocolitano"],
  },
  {
    id: "picole-premium",
    title: "Picolé Premium",
    price: 12,
    unit: "cada",
    color: "#F59E0B",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/37418d5d4c2c6013_WhatsApp%20Image%202026-10-17%20at%2015.07.41.jpeg",
    flavors: ["Frutas", "Cookies", "Brownie", "Doce de Leite", "Caramelo", "Laster", "Pistache", "White", "Chocolate Zero", "Unicórnio"],
  },
  {
    id: "picole-leite",
    title: "Picolé ao Leite",
    price: 6,
    unit: "cada",
    color: "#06B6D4",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/bac9600f48a0378e_WhatsApp%20Image%202026-10-17%20at%2015.07.40%20%281%29.jpeg",
    flavors: ["Chiclete", "Coco", "Nata", "Banana", "Chocolate", "Morango", "Leite Condensado", "Milho Verde"],
  },
  {
    id: "picole-fruta",
    title: "Picolé de Fruta",
    price: 5,
    unit: "cada",
    color: "#10B981",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/2d874f40348e4204_WhatsApp%20Image%202026-10-17%20at%2015.07.40.jpeg",
    flavors: ["Maracujá", "Uva", "Limão", "Abacaxi", "Morango"],
  },
];

export const IMAGES = {
  hero: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/x7a08xy2_IMG_4383.webp",
  roleta: "https://customer-assets-jai6qajn.emergentagent.net/job_order-acai-now/artifacts/xiecjn4v_WhatsApp%20Image%202026-09-17%20at%2013.45.58%20%281%29.jpeg",
  preparo: "https://images.pexels.com/photos/11094179/pexels-photo-11094179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const formatBRL = (v) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const slug = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-");

export const buildOrderMessage = (items, info, total) => {
  const fee = info.fee || 0;
  const spoons = info.spoons || 0;
  const spoonsCost = spoons * SPOON_PRICE;
  const lines = ["*NOVO PEDIDO — GIGA AÇAÍ*", ""];
  items.forEach((it, i) => {
    lines.push(`*${i + 1}.* ${it.title}${it.qty > 1 ? `  x${it.qty}` : ""}`);
    if (it.details && it.details.length) lines.push(`   ${it.details.join(", ")}`);
    lines.push(`   ${formatBRL(it.unitPrice * it.qty)}`);
  });
  lines.push("", `*Subtotal:* ${formatBRL(total)}`);
  if (spoons > 0)
    lines.push(`*Colheres:* ${spoons} × ${formatBRL(SPOON_PRICE)} = ${formatBRL(spoonsCost)}`);
  if (info.mode === "entrega") {
    const feeText = fee === 0 ? "Grátis" : formatBRL(fee);
    lines.push(`*Taxa de entrega:* ${feeText}${info.distanceKm ? ` (≈ ${String(info.distanceKm).replace(".", ",")} km da loja)` : ""}`);
  }
  lines.push(`*TOTAL: ${formatBRL(total + fee + spoonsCost)}*`, "", `*Nome:* ${info.name}`);
  if (info.phone) lines.push(`*WhatsApp:* ${info.phone}`);
  lines.push(`*Recebimento:* ${info.mode === "entrega" ? "Entrega" : "Retirada no balcão"}`);
  if (info.mode === "entrega") lines.push(`*Endereço:* ${info.address}`);
  lines.push(`*Pagamento:* ${info.payment}`);
  if (info.notes && info.notes.trim()) lines.push(`*Obs:* ${info.notes.trim()}`);
  return lines.join("\n");
};
